import firebase from "firebase/app";
import "firebase/auth";

class UsersService {
    _DB_KEY = 'users';

    getUsers = async (db) => {
        return db.collection(this.dbKey).get();
    }

    createUser = async (db, payload) => {
        const { user } = await firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password);

        return this.setUserRole(db, user.uid, payload.email, payload.role, payload.firstName, payload.lastName);
    }

    getUserByUuid = async (db, uuid) => {
        const documentRef = db.collection(this.dbKey).doc(uuid);

        return documentRef.get();
    }

    setUserRole = async (db, uid, email, role, firstName, lastName) => {
        const document = db.collection(this.dbKey).doc(uid);
        const body = {
            email,
            firstName,
            lastName,
            role
        };

        return document.set(body);
    }

    verifyOtp = async (db, email, otp) => {
        const documentRef = db.collection(this.dbKey).where(`email`, "==", email);
        const { docs } = await documentRef.get();
        const user = docs.map((user) => user.data())[0];

        if (user) {
            const validOtp = user.otp;
            const userRef = db.collection(this.dbKey).doc(docs[0].ref.id);

            if (otp === validOtp) {
                await userRef.update({
                    otp: null
                });

                return new Promise((resolve) => {
                    resolve('Correct OTP');
                });
            } else {
                return new Promise((resolve) => {
                    resolve('Wrong OTP');
                });
            }
        } else {
            return new Promise((resolve) => {
                resolve('User not found');
            });
        }
    }

    get dbKey() {
        return this._DB_KEY
    }
}

export default new UsersService();



// WEBPACK FOOTER //
// ./src/services/users.js